angular.module('impactx.profile').controller('PasswordChangeCtrl', ['$scope', '$mdDialog', 'dataGen', '$context', '$mdToast', PasswordChange]);

function PasswordChange($scope, $mdDialog, dataGen, $context, $mdToast)
{
    $scope.getPageData = function ()
    {
        dataGen.getData($scope, {id: $context.userId}, "/user/password/view");
    };
    $scope.getPageData();

    $scope.closeDialog = function ()
    {
        $mdDialog.hide();
    };

    $scope.savePassword = function ()
    {
        var dataObj = {
            data: $scope.data
        };
        dataGen.post($scope, dataObj, "/user/password/save").then(function ()
        {
            if ($scope.data.passwordChange == null || $scope.data.passwordChange == undefined)
            {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.savesuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
                $scope.closeDialog()
            }
        });
    };
}